import CommonService from "./common.service";

const BASE = "/public/procurement-services";

const procurementServicesPublicService = {
  getCatalogue: () => CommonService.get(BASE, {}, { silent: true }),
  getBySlug: (slug) => CommonService.get(`${BASE}/${encodeURIComponent(slug)}`, {}, { silent: true }),
};

export default procurementServicesPublicService;
